import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import BenefitsLevelModal from "@/components/Modals/Benefits/BenefitsLevelModal.vue";
import BenefitsTeamManagerModal from "@/components/Modals/Benefits/BenefitsTeamManagerModal.vue";
import BenefitsFixedModal from "@/components/Modals/Benefits/BenefitsFixedModal.vue";
import BenefitsAddLevelModal from "@/components/Modals/Benefits/BenefitAddLevelModal.vue";
import BenefitsAddTeamManagerModal from "@/components/Modals/Benefits/BenefitAddTeamManagerModal.vue";
//@ts-ignore
import { AuthenticationContext } from "vue-adal";
let BenefitsModal = class BenefitsModal extends Vue {
    shortDate(date) {
        if (date !== null) {
            return window.dateHandler.formatDateNoTime(date);
        }
    }
    clearBenefitId() {
        this.$data.benefitId = null;
    }
    closeModal() {
        //@ts-ignore
        this.close();
    }
    //opens the fixed benefit modal
    openFixedBenefitModal(benefit) {
        this.$data.benefitId = benefit.id;
        this.$data.showFixedBenefitModal = true;
    }
    //load the global levels
    loadEmployeeBenefits() {
        this.$store
            .dispatch("getEmployeeBenefits", this.$props.employee.userId)
            .then((response) => {
            this.$data.benefits = response.data.sort((a, b) => (window.dateHandler.convertToUTCTime(a.from) > window.dateHandler.convertToUTCTime(b.from)) ? -1 : 1);
            console.log(this.$data.benefits);
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/BenefitsModal.vue - loadEmployeeBenefits");
        });
    }
};
BenefitsModal = __decorate([
    Component({
        data() {
            return {
                trueVal: true,
                loading: true,
                theme: this.$store.getters.getTheme,
                benefits: null,
                selectedBenefit: [],
                //modals
                showFixedBenefitModal: false,
                showTeamManagerBenefitModal: false,
                showLevelBenefitModal: false,
                showAddLevelModal: false,
                showAddTeamManagerBenefitModal: false,
                benefitId: null,
                benfitHeaders: [
                    { text: "Name", value: "name" },
                    { text: "From", value: "from" },
                    { text: "To", value: "to" },
                    { text: "Type", value: "type" },
                    { text: "", value: "edit" },
                ],
            };
        },
        props: ["employee"],
        mounted() {
            this.$data.loading = false;
            this.loadEmployeeBenefits();
            //recieve event to reload data
            window.eventBus.$on("reloadBenefitsForUser", () => {
                this.loadEmployeeBenefits();
            });
        },
        watch: {
            "showFixedBenefitModal": function (newVal) {
                if (!newVal)
                    this.clearBenefitId();
            },
            "showTeamManagerBenefitModal": function (newVal) {
                if (!newVal)
                    this.clearBenefitId();
            },
            "showLevelBenefitModal": function (newVal) {
                if (!newVal)
                    this.clearBenefitId();
            },
            "showAddLevelModal": function (newVal) {
                if (!newVal)
                    this.clearBenefitId();
            },
            "showAddTeamManagerBenefitModal": function (newVal) {
                if (!newVal)
                    this.clearBenefitId();
            },
        },
        computed: {
            isAdmin() {
                try {
                    return AuthenticationContext.checkRoles(["Admin"]);
                }
                catch {
                    return false;
                }
            },
            disableAddNew() {
                return (this.$data.benefits &&
                    this.$data.benefits.some((benefit) => !benefit.to));
            },
            showModal: {
                get() {
                    return this.$data.trueVal;
                },
                set(newValue) {
                    this.$data.trueVal = newValue;
                    if (this.$data.trueVal === false) {
                        this.$emit("close"); //we need to send the close event if the dialog is closed by clicking outside rather than on the button
                    }
                },
            },
        },
        methods: {
            close() {
                this.$emit("close");
            },
        },
        components: {
            BenefitsLevelModal,
            BenefitsTeamManagerModal,
            BenefitsFixedModal,
            BenefitsAddLevelModal,
            BenefitsAddTeamManagerModal,
        },
    })
], BenefitsModal);
export default BenefitsModal;
